import { ChartDomain } from '../..';

export type VizTypeSelection = 'table' | 'line' | 'bar';

export type ChartState = 'dirty' | 'committed';

export interface Metric {
  id: number;
  token: string;
  dataSourceId: number;
  dataSourceName: string;
  name: string;
  desc: string;
  label: string;
  type: string;
  sql: string;
  timestamp: string;
  timeGrains: string[];
  dimensions: string[];
  attrs: MetricAttr[];
}

export enum AttrType {
  Dimension = 'Dimension',
  Timestamp = 'Timestamp',
  Metric = 'Metric',
}

type MetricAttr = Dimension;
export interface Dimension {
  name: string;
  desc: string;
  type: AttrType;
  dataType: string;
}

export interface MacroSpec {
  name: string;
  grain: string;
  timestamp: string;
  dimensions: string[];
  startDate: string | undefined;
  endDate: string | undefined;
  where: string[];
}

export interface NewMetricQueryData {
  metricId: number;
  metricToken: string;
  dataSourceId: number;
  vizType: VizTypeSelection;
  chart: ChartDomain.Chart;
  dbtSql: string;
  mappingId: string;
}
